import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { API_ENDPOINTS } from "../api/endpoints";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  const fetchUserData = async () => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    const userName = Cookies.get("userName");

    if (!token || !userId || !userName) return;

    const apiUsers = API_ENDPOINTS.externa.user(userId);

    try {
      const response = await fetch(apiUsers, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authentication-Token": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.messages?.[0] || "Error al obtener datos del usuario.");
        return;
      }

      const data = await response.json();

      const permisoRes = await fetch(API_ENDPOINTS.interna.validate_user, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: userName }),
      });

      if (!permisoRes.ok) {
        setError("Error al validar permisos del usuario.");
        return;
      }

      const permisoData = await permisoRes.json();

      setUserData({
        ...data,
        es_superusuario: permisoData.es_superusuario,
      });
      setError(null);
    } catch (err) {
      console.error("Error durante la consulta de usuario:", err);
      setError("Hubo un problema con la consulta a la API.");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        error,
        setError,
        reloadUser: fetchUserData, // <- exportar función
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
